/**
 * PKCE helpers (RFC 7636) for Starfleet public OIDC clients.
 */

const VERIFIER_LENGTH = 32;

function bytesToBase64Url(bytes) {
  let binary = '';
  bytes.forEach(b => {
    binary += String.fromCharCode(b);
  });
  const base64 = btoa(binary);
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/**
 * @returns {string} code_verifier (43+ chars, URL-safe)
 */
export function generateCodeVerifier() {
  const bytes = new Uint8Array(VERIFIER_LENGTH);
  crypto.getRandomValues(bytes);
  return bytesToBase64Url(bytes);
}

/**
 * @param {string} codeVerifier
 * @returns {Promise<string>} code_challenge (S256, base64url)
 */
export async function generateCodeChallenge(codeVerifier) {
  if (!codeVerifier || typeof codeVerifier !== 'string') {
    throw new TypeError('codeVerifier must be a non-empty string');
  }
  const data = new TextEncoder().encode(codeVerifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return bytesToBase64Url(new Uint8Array(digest));
}

/**
 * @returns {string} opaque state for CSRF protection
 */
export function generateOAuthState() {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return bytesToBase64Url(bytes);
}
